import React from 'react';
import { VariantProps, cva } from 'class-variance-authority';

import { cn } from '~/helpers/utils';

const linkVariant = cva(
  'button',
  {
    variants: {
      variant: {
        primary: 'button--primary',
        primaryGradient: 'button--primary-gradient',
        secondary: 'button--secondary',
        secondaryGradient: 'button--secondary-gradient',
        blue: 'button--blue',
        default: 'button--default',
        outline: 'button--outline',
        outlineGrey: 'button--outline-grey',
        disabled: 'button--disabled',
      },
      size: {
        small: 'button--sm',
        medium: 'button--md',
        large: 'button--lg',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'medium',
    },
  }
);

export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement>, VariantProps<typeof linkVariant> {
  ignoreLowercase?: boolean;
}

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ ignoreLowercase, variant, size, type, className, href, ...props }, ref) => {
    return (
      <a
        className={cn(linkVariant({ variant, size }), className)}
        ref={ref}
        href={ignoreLowercase ? href : href?.toLowerCase()}
        {...props}
      />
    )
  }
)

Link.displayName = "Link";

export { Link, linkVariant };